module.exports = __webpack_public_path__ + "static/media/en-cancel-service_2.7e5acf14.png";